import React from "react";
import FileViewer from "react-file-viewer";
import useToaster from "../../customHook/useToaster";

const DocxOpener = ({ fileName, fileType }) => {
  const { showToast } = useToaster();
  const containerRef = React.useRef(null);
  return (
    <div className="App">
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            ref={containerRef}
            style={{
              width: "600px",
              height: "600px",
            }}
          >
            <FileViewer
              key={fileType}
              fileType={fileType}
              filePath={fileName}
              errorComponent={<p>errorComponent</p>}
              onError={(error) => showToast("FileViewer error:", "error", true)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
// };

export default DocxOpener;
